export const areStringsEqual = (a: string, b: string) => a?.toLowerCase() === b?.toLowerCase()
